<template>
  <div id="app" :class="[pageClass, { mobileMenuOpened: !isMenuActive }]">
    <!--<div id="app">-->
    <transition name="preloader-fade">
      <div class="preloader" v-if="showPreloader">
        <!--<div class="preloader-img">-->
        <!---->
        <!--&lt;!&ndash;<div class="loader-2"><span></span></div>&ndash;&gt;-->
        <!--<svg-icon type="icon-logo" />-->
        <!--</div>-->
        <img
          src="@/assets/img/logo-colored.svg"
          alt="yurt yurtlarburada"
          class="preloader-svg"
          width="400"
        />
      </div>
    </transition>

    <HeaderNav @open="showMenus" />

    <Mobile v-if="showMenu" />

    <div class="wrapper">
      <!--aa-->
      <transition name="fade">
        <router-view />
      </transition>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer'
import HeaderNav from '@/components/HeaderNav'
import Mobile from '@/components/Mobile'
import { GET_GENERAL_SETTINGS, SHOW_MENU } from '@/store/actions.type'
import { mapGetters } from 'vuex'
// import Breadcrumbs from '@/components/Breadcrumbs'
export default {
  name: 'app',
  /*   components: {
    Breadcrumbs
  },  */
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.settings ? this.settings.setting.title : '',
      // all titles will be injected into this template
      // { name: 'description', content: this.settings ? this.settings.setting.description : '' }

      titleTemplate: '%s | Yurtlar Burada',
      meta: [
        // { vmid: 'description', name: 'description', content: this.settings ? this.settings.setting.description : '' },
        // { vmid: 'keywords', name: 'keywords', content: this.settings ? this.settings.setting.keywords : '' },

        {
          property: 'og:title',
          content: this.settings ? this.settings.setting.title : ''
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:url',
          content: 'https://www.yurtlarburada.com'
        },
        {
          property: 'og:image',
          content: 'https://www.yurtlarburada.com/logo.png'
        },
        {
          property: 'og:description',
          content: this.settings ? this.settings.setting.description : ''
        },
        {
          property: 'og:site_name',
          content: 'Yurtlar Burada'
        },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@yurtlarburada' },
        {
          name: 'twitter:title',
          content: this.settings ? this.settings.setting.title : ''
        },
        {
          name: 'twitter:description',
          content: this.settings ? this.settings.setting.description : ''
        },
        { name: 'twitter:creator', content: '@yurtlarburada' },
        {
          name: 'twitter:image',
          content: 'https://www.yurtlarburada.com/logo.png'
        }
      ]
      /*       link: [
        { vmid: 'canonical', rel: 'canonical', href: 'https://www.yurtlarburada.com' },
        { rel: 'favicon', href: 'favicon.ico' }
      ] */
    }
  },
  data() {
    return {
      display: false
    }
  },
  components: {
    HeaderNav,
    Footer,
    Mobile
  },
  methods: {
    showMenus() {
      this.$store.dispatch(SHOW_MENU, !this.showMenu)
    },
    getGeneralSettings() {
      this.$store.dispatch(GET_GENERAL_SETTINGS)
    }
  },
  computed: {
    ...mapGetters([
      'pageClass',
      'showPreloader',
      'showMenu',
      'settings',
      'isMenuActive'
    ])
  },
  created() {
    this.getGeneralSettings()
  },
  watch: {
    $route() {
      let set = this.settings
    }
  }
}
</script>
<style lang="scss">
@import 'assets/scss/bootstrap.min';
@import 'assets/scss/normalize';
@import 'assets/scss/global';
@import 'assets/scss/helpers';
@import 'assets/scss/swiper';
@import 'assets/scss/components/shapes';
@import 'assets/scss/components/form';
//fade

.preloader-fade-enter-active {
  transition: all 0.25s ease-in-out;
}

.preloader-fade-leave-active {
  transition: all 0.25s ease-in-out;
}

.preloader-fade-enter {
  opacity: 0;
}

.preloader-fade-leave-to {
  opacity: 0;
}

.menuDisplay {
  display: none;
}
</style>
